import { defineComponent as c, inject as m, computed as n, openBlock as a, createElementBlock as p, createBlock as u, resolveDynamicComponent as h, unref as f, normalizeStyle as d, normalizeClass as g } from "vue";
import y from "./index281.js";
import { routerKey as C } from "vue-router";
const x = /* @__PURE__ */ c({
  __name: "BaseLogoModa",
  props: {
    size: { default: 44 },
    homePath: { default: "/" }
  },
  setup(s) {
    const e = s, t = m(C, null), r = n(() => ["inline-block", "cursor-pointer"].join(" ")), l = n(() => {
      const o = {};
      return e.size && (o.width = `${e.size}px`, o.height = `${e.size}px`), o;
    }), i = async () => {
      if (t) {
        if (e.homePath === "/" || e.homePath === "") {
          await t.push({ name: "home" });
          return;
        }
        await t.push(e.homePath);
      }
    };
    return (o, b) => (a(), p("button", {
      type: "button",
      class: "border-0 bg-transparent p-0",
      onClick: i
    }, [
      (a(), u(h(f(y)), {
        class: g(r.value),
        style: d(l.value),
        role: "img",
        "aria-label": "moda logo"
      }, null, 8, ["class", "style"]))
    ]));
  }
});
export {
  x as default
};
